import { render, staticRenderFns } from "./success_pay.vue?vue&type=template&id=a4964d2a&scoped=true"
import script from "./success_pay.vue?vue&type=script&lang=js"
export * from "./success_pay.vue?vue&type=script&lang=js"
import style0 from "./success_pay.vue?vue&type=style&index=0&id=a4964d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4964d2a",
  null
  
)

export default component.exports